import { render, staticRenderFns } from "./verticalLayout.vue?vue&type=template&id=bdd313ba&scoped=true&"
import script from "./verticalLayout.vue?vue&type=script&lang=js&"
export * from "./verticalLayout.vue?vue&type=script&lang=js&"
import style0 from "./verticalLayout.vue?vue&type=style&index=0&id=bdd313ba&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdd313ba",
  null
  
)

export default component.exports